import React from 'react';
import moment from 'moment';
import routes from '~/apiRouter';
import Loader from '~/components/ui/Loader';
import staticCities, { onlineCityCode } from '~/data/fakeCities'; // its not fake, its real
import { filterAvailableOnlineEvents } from '~h/eventFilters';

moment.locale('ru');

export default class BlockCTAFreeEvents extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      events: [],
      city: staticCities.find(c => c.selected) || null,
      cities: staticCities || [],
      isCitySelectorOpened: false,
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  filterEvents = events => {
    const { city } = this.state;

    const offlineEvents = events
      .filter(event => event.CITY?.KLADR === city.kladr)
      .filter(event => Number(event.PRICE) === 0)
      .filter(event => new Date(event.START_DATE).getTime() > Date.now());

    const onlineEvents = events
      .filter(event => event.CITY_CODE === onlineCityCode)
      .filter(event => Number(event.PRICE) === 0)
      .filter(event => new Date(event.START_DATE).getTime() > Date.now());

    const filteredEvents = offlineEvents.concat(onlineEvents);

    const availableEvents = filterAvailableOnlineEvents(
      filteredEvents,
      city.kladr,
    );
    return availableEvents
      .sort(
        (first, second) =>
          new Date(first.START_DATE).getTime() -
          new Date(second.START_DATE).getTime(),
      )
      .slice(0, 3);
  };

  loadData() {
    const { disciplines } = this.props;

    if (!disciplines?.length) {
      this.setState({
        events: [],
        loading: false,
      });

      return;
    }

    const options = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    };

    const disciplineCodes = disciplines.length > 0 ? disciplines.join('/') : '';
    const taggedPageCode =
      this.props.pageCode || $('#page-editor').data('page_code');
    const pageCode = taggedPageCode ? `/page/${taggedPageCode}` : '';
    const url = `${routes.playbill.get}${disciplineCodes}${pageCode}`;
    fetch(url, options)
      .then(response => response.json())
      .then(json => {
        if (json.status === 'success') {
          const events = json.data?.EVENTS || [];
          this.setState({
            events,
            loading: false,
          });
        } else {
          this.setState({
            error: json.errors || ['Ошибка загрузки данных расписания'],
            loading: false,
          });
        }
      })
      .catch(error => {
        this.setState({
          error: [`Ошибка загрузки расписания с сервера: ${error.message}`],
          loading: false,
        });
      });
  }

  // eslint-disable-next-line class-methods-use-this
  getDate(date) {
    return moment(date).format('D MMMM');
  }

  // eslint-disable-next-line class-methods-use-this
  getUniqueNamesNumber(events) {
    return new Set(events.map(event => event.SHORT_NAME)).size;
  }

  renderEvents() {
    const { events } = this.state;
    const filteredEvents = this.filterEvents(events);

    if (!filteredEvents?.length) {
      return <div>Нет доступных для регистрации мероприятий</div>;
    }

    if (
      filteredEvents.length > 1 &&
      this.getUniqueNamesNumber(filteredEvents) === 1
    ) {
      return this.renderSingleTitleEvents(filteredEvents);
    }

    return this.renderLineEvents(filteredEvents);
  }

  toggleCitySelectorState = e => {
    e.preventDefault();
    const { isCitySelectorOpened } = this.state;
    this.setState({ isCitySelectorOpened: !isCitySelectorOpened });
  };

  getCurrentMorphologyCity() {
    const { city } = this.state;
    // noinspection NonAsciiCharacters
    const morphologyMapping = {
      Москва: 'Москве',
      'Санкт-Петербург': 'Санкт-Петербурге',
      Казань: 'Казани',
      Екатеринбург: 'Екатеринбурге',
      Новосибирск: 'Новосибирске',
      Воронеж: 'Воронеже',
      Краснодар: 'Краснодаре',
      'Ростов-На-Дону': 'Ростове-на-Дону',
      'Другие города': 'других городах',
    };
    return morphologyMapping[city.name] || `городе ${city.name}`;
  }

  prepareCityDrop = () => {
    const { city, cities } = this.state;
    return cities.map(c => {
      const classes = ['town__link'];
      if (c === city) classes.push('is-active');
      return (
        <button
          type="button"
          key={c.id}
          className={classes.join(' ')}
          onClick={() =>
            this.setState({ isCitySelectorOpened: false, city: c })
          }
        >
          {c.name}
        </button>
      );
    });
  };

  renderCitySelector() {
    const { isCitySelectorOpened } = this.state;
    const dropdownClasses = ['town'];
    if (isCitySelectorOpened) dropdownClasses.push('is-open');

    return (
      <div className="cta-free__town-container">
        <div className="cta__info-group">
          <div className="cta__label">
            Ближайшие мероприятия{' '}
            <div className="cta__city-container">
              в&nbsp;
              {/* eslint-disable */}
              <a className="droplink" onClick={this.toggleCitySelectorState}>
                {this.getCurrentMorphologyCity()}
              </a>
              {/* eslint-enable */}
              <div className={dropdownClasses.join(' ')}>
                <div className="town__drop">{this.prepareCityDrop()}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderSingleTitleEvents(events) {
    const title = events[0]?.SHORT_NAME;
    return (
      <div className="cta-free__single-title-container">
        <div className="cta-free__event-name">
          {title}{' '}
          {events[0]?.CITY_CODE === onlineCityCode && (
            <span className="popup-info__content">
              <span className="title online-tag cta-free__online-tag" />
            </span>
          )}
        </div>
        <div className="cta-free__single-title-events">
          {events.map(event => {
            return (
              <div className="cta-free__single-title-event">
                <div className="cta-free__event-date cta-free__event-date--single">
                  {this.getDate(new Date(event.START_DATE))}
                </div>
                <div className="cta-free__event-description cta-free__event-description--single">
                  {event.DESCRIPTION}
                </div>
                <a
                  className="btn btn--primary course-reg__btn"
                  href={`${
                    event.EVENT_PAGE?.DETAIL_PAGE_URL
                  }registration/${event.CODE.toLowerCase()}/`}
                >
                  Зарегистрироваться
                </a>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  renderLineEvents(events) {
    return events.map(event => (
      <div className="cta-free__inline-event-container">
        <div className="cta-free__event-name-container">
          <div className="cta-free__event-name-subcontainer">
            <div className="cta-free__event-name">{event.SHORT_NAME}</div>
            {event?.CITY_CODE === onlineCityCode && (
              <span className="popup-info__content">
                <span className="title online-tag cta-free__online-tag" />
              </span>
            )}
          </div>
          <div className="cta-free__event-date">
            {this.getDate(new Date(event.START_DATE))}
          </div>
          <div className="cta-free__event-description">{event.DESCRIPTION}</div>
        </div>

        <a
          className="btn btn--primary course-reg__btn"
          href={`${
            event.EVENT_PAGE?.DETAIL_PAGE_URL
          }registration/${event.CODE.toLowerCase()}/`}
        >
          Зарегистрироваться
        </a>
      </div>
    ));
  }

  renderErrorMessage() {
    return (
      <div className="cta__error-container">
        <div className="cta__error-icon" />
        <div className="cta__error-message">
          Ошибка блока: не установлена дисциплина. Этот блок будет скрыт от
          посетителей, если не установить связку с дисциплиной в настройках
          блока.
        </div>
      </div>
    );
  }

  render() {
    const { image, title, disciplines } = this.props;
    const { loading, error, events } = this.state;

    if (loading) return <Loader />;

    if (error) {
      const errors = error.map((e, index) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <p key={`err_${index}`} className="txt txt--center txt--red">
            {e}
          </p>
        );
      });
      return (
        <div className="cta">
          <div className="cta__info">{errors}</div>
        </div>
      );
    }

    const imageClasses = ['collage__image', 'collage__image--cta-free'];
    if (!image) imageClasses.push('collage__image--cta-free--only-title');
    if (!image && !title) imageClasses.push('hidden');

    const titleClasses = ['collage__descr--cta-free', 'txt-accent'];
    if (!image) titleClasses.push('cta-free__title', 'cta-free__title--only');

    const wrapperClasses = ['collage', 'collage--cta-free'];
    if (!image && !title && !events?.length) wrapperClasses.push('hidden');

    return (
      <React.Fragment>
        {disciplines?.length === 0 && this.renderErrorMessage()}
        <div className={wrapperClasses.join(' ')}>
          <div
            className={imageClasses.join(' ')}
            style={{
              backgroundImage: `url('${image}')`,
              minHeight: image ? '200px' : 'auto',
            }}
          >
            {title && (
              <div className={titleClasses.join(' ')}>
                <span>{title}</span>
              </div>
            )}
          </div>
          {events?.length > 0 && (
            <React.Fragment>
              <div className="cta-free__content">
                {this.renderCitySelector()}
                {this.renderEvents()}
              </div>
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    );
  }
}
